/*
  Used to mapping the activeFilters to be queryParamFilters (in Array)
  examples:
  queryParamFilters = [
    "created_on lte 2023-08-29T17:00:00Z",
    "created_on gte 2023-08-29T17:00:00Z",
    "status.name eq 'DRAFT'",
  ]
*/

const queryFiltersMappings = {
  eq: (key, value) => {
    return `${key} eq ${value[0]}`
  },
  gte: (key, value) => {
    return `${key.replace(/:gte/g, '')} gte ${value}`
  },
  lte: (key, value) => {
    return `${key.replace(/:lte/g, '')} lte ${value}`
  },
  in: (key, values) => {
    const formattedValues = values.map((value) => `${value}`)
    return `${key.replace(/:in/g, '')} in (${formattedValues.join(' ')})`
  },
}

const filterMappings = {
  'status.name': queryFiltersMappings.eq,
  'created_on:gte': queryFiltersMappings.gte,
  'created_on:lte': queryFiltersMappings.lte,
  'load_weight:gte': queryFiltersMappings.gte,
  'load_weight:lte': queryFiltersMappings.lte,
  'load_volume:gte': queryFiltersMappings.gte,
  'load_volume:lte': queryFiltersMappings.lte,
  'load_min_temperature:gte': queryFiltersMappings.gte,
  'load_max_temperature:lte': queryFiltersMappings.lte,
  'shipped_customer.id:in': queryFiltersMappings.in,
  'billed_customer.id:in': queryFiltersMappings.in,
  'vendor.id:in': queryFiltersMappings.in,
  'origin_address.id:in': queryFiltersMappings.in,
  'destination_address.id:in': queryFiltersMappings.in,
  shipment_type: queryFiltersMappings.in,
  created_on: queryFiltersMappings.eq,
  event: queryFiltersMappings.eq,
  'event:in': queryFiltersMappings.in,
  'user_group.id:in': queryFiltersMappings.in,
  'product_category.id:in': queryFiltersMappings.in,
  'expected_delivered_on:gte': queryFiltersMappings.gte,
  'expected_delivered_on:lte': queryFiltersMappings.lte,
  line_order: queryFiltersMappings.in,
}

export default filterMappings
